import { defineComponent as _defineComponent } from 'vue'
import { resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, defineAsyncComponent } from 'vue';
import { InlineMediaType } from '@superthread-com/extension-inline-media/src/index';
import type EditorService from '@/services/EditorService';


export default /*@__PURE__*/_defineComponent({
  __name: 'SpecificMedia',
  props: {
    type: {},
    editor: {}
  },
  setup(__props: any) {

const props = __props;

const comp = computed(() => {
  if (props.type === InlineMediaType.Video) {
    return defineAsyncComponent(() => import(/* webpackChunkName: "genericMedia" */ './Video.vue'));
  } else {
    return defineAsyncComponent(() => import(/* webpackChunkName: "genericMedia" */ './File.vue'));
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(comp.value), {
    editor: props.editor
  }, null, 8, ["editor"]))
}
}

})